// ══════════════ OBJETS TROUVÉS — DÉCLARATION TERRAIN (2 étapes) ══════════════
// Extrait de GerantClientUI.jsx (refacto étape 2, 06/07/2026).
// Brique partagée utilisée par SecObjets, GerantUI, StaffUI, ProvUI.
// Dépend de Facturation.jsx (nextCasier, OT_CATS) — pas de cycle (Facturation n'importe pas OTQuick).
import React, { useState, useEffect, useMemo } from 'react';
import { today, now, fd, compressToDataUrl } from '../utils.js';
import { nextCasier, OT_CATS } from './Facturation.jsx';

export function OTQuick({biens,objets,setObjets,otBacs,setOtBacs,sejours,statutAppts,onClose}){
  const[step,setStep]=useState(1);
  const[type,setType]=useState(null);
  const[f,setF]=useState({bid:'',date:today(),desc:'',photo:null,notes:'',cat:'',sousType:'identite',entame:false,destination:'salarie'});
  const set=(k,v)=>setF(x=>({...x,[k]:v}));

  // Séjour le plus récent du bien — cherche dans sejours7 (iCal) ET dans les départs manuels (statutAppts)
  const sejourAuto=useMemo(()=>{
    if(!f.bid)return null;
    // Source 1 : séjours iCal / saisis
    const fromSejours=(sejours||[])
      .filter(s=>s.bid===f.bid&&(s.dateDepart||s.depart||'')<=f.date)
      .sort((a,b)=>(b.dateDepart||b.depart||'').localeCompare(a.dateDepart||a.depart||''))[0]||null;
    if(fromSejours)return fromSejours;
    // Source 2 : départs manuels dans statutAppts (clés ad_dep_YYYY-MM-DD)
    const sa=statutAppts||{};
    let bestDep=null;
    Object.entries(sa).forEach(([k,v])=>{
      if(!k.startsWith('ad_dep_'))return;
      const dateStr=k.replace('ad_dep_','');
      if(dateStr>f.date)return;
      const arr=Array.isArray(v)?v:[];
      arr.forEach(entry=>{
        if(entry.bid===f.bid&&(!bestDep||dateStr>bestDep.date)){
          bestDep={date:dateStr,heure:entry.heure||'10:00',_fromStatutAppts:true};
        }
      });
    });
    if(bestDep)return{id:null,dateDepart:bestDep.date,nomLocataire:null,_fromStatutAppts:true};
    return null;
  },[f.bid,f.date,sejours,statutAppts]);

  // sejourId/nomLocataire injectés au moment du save() depuis sejourAuto — pas de useEffect (évite boucle)

  const save=()=>{
    // Enrichit f avec le séjour auto-détecté si pas déjà renseigné
    const sejourPatch=sejourAuto&&!f.sejourId?{sejourId:sejourAuto.id,nomLocataire:sejourAuto.nomLocataire||sejourAuto.nom||''}:{};
    const base={...f,...sejourPatch,id:'ot'+Date.now(),type,declaredAt:now()};
    let newOT;
    if(type===1){
      newOT={...base,statut:'coffre',localisation:'coffre',ref:'OT-'+new Date().getFullYear()+'-'+String((objets||[]).length+1).padStart(3,'0')};
    } else if(type===2){
      const dateLimiteRecup=new Date(f.date);dateLimiteRecup.setMonth(dateLimiteRecup.getMonth()+1);
      newOT={...base,statut:'attente_retour',ref:'OT-'+new Date().getFullYear()+'-'+String((objets||[]).length+1).padStart(3,'0'),
        dateLimiteRecup:dateLimiteRecup.toISOString().slice(0,10),dateNotification:f.date};
    } else if(type===4){
      const bacOuvert=(otBacs||[]).find(b=>b.statut==='ouvert');
      let bacId;
      if(bacOuvert){bacId=bacOuvert.id;}
      else{bacId='bac'+Date.now();setOtBacs(prev=>[...(prev||[]),{id:bacId,dateOuverture:today(),statut:'ouvert'}]);}
      const casier=nextCasier(objets||[]);
      newOT={...base,statut:'bac',bacId,casier,ref:'OT-'+new Date().getFullYear()+'-'+String((objets||[]).length+1).padStart(3,'0')};
    }
    setObjets(prev=>[...(prev||[]),newOT]);
    onClose();
  };

  // Référence pré-calculée pour affichage terrain avant save()
  const refPreview='OT-'+new Date().getFullYear()+'-'+String((objets||[]).length+1).padStart(3,'0');

  const TYPES=[
    {t:1,emoji:'🔒',label:'Objet de valeur',sub:'Bijou, montre, électronique, espèces, clés'},
    {t:2,emoji:'🪪',label:'Identité / Paiement',sub:'CNI, passeport, carte bancaire'},
    {t:4,emoji:'📦',label:'Autre objet',sub:'Vêtement, livre, chargeur, divers'},
  ];

  if(step===1)return(<div style={{display:'flex',flexDirection:'column',gap:10}}>
    <div style={{fontSize:13,color:'var(--si)',marginBottom:4}}>Quel type d&apos;objet avez-vous trouvé ?</div>
    {TYPES.map(({t,emoji,label,sub})=>(
      <button key={t} onClick={()=>{setType(t);setStep(2);}}
        style={{display:'flex',alignItems:'center',gap:14,padding:'12px 16px',borderRadius:12,border:'2px solid var(--li)',background:'var(--bg)',cursor:'pointer',textAlign:'left',width:'100%'}}>
        <span style={{fontSize:28,lineHeight:1}}>{emoji}</span>
        <div><div style={{fontWeight:700,fontSize:14}}>{label}</div><div style={{fontSize:12,color:'var(--si)'}}>{sub}</div></div>
      </button>
    ))}
    <button onClick={onClose} className="btn bgh" style={{marginTop:4}}>Annuler</button>
  </div>);

  // Étape 2 — formulaire selon type
  const commonFields=(<>
    <div><label className="fl">Appartement *</label>
      <select value={f.bid} onChange={e=>set('bid',e.target.value)}>
        <option value="">— Sélectionner —</option>
        {biens.map(b=><option key={b.id} value={b.id}>{b.name}</option>)}
      </select>
    </div>
    <div><label className="fl">Date de découverte</label><input type="date" value={f.date} onChange={e=>set('date',e.target.value)}/></div>
  </>);

  const photoField=(<div>
    <label className="fl">Photo{type===1?' (recommandée)':' (optionnel)'}</label>
    <div style={{border:'2px dashed var(--li)',borderRadius:10,padding:'12px',textAlign:'center',cursor:'pointer',background:'var(--bg)',fontSize:12,color:'var(--si)'}}
      onClick={()=>document.getElementById('ot-q-photo-new').click()}>
      {f.photo?<span style={{color:'var(--ok)',fontWeight:700}}>✓ Photo ajoutée</span>:<span>📷 Prendre une photo</span>}
    </div>
    <input id="ot-q-photo-new" type="file" accept="image/*" capture="environment" style={{display:'none'}}
      onChange={e=>{if(e.target.files[0]){const file=e.target.files[0];compressToDataUrl(file,{maxDim:1280,quality:0.7}).then(u=>set('photo',u)).catch(()=>{compressToDataUrl(file,{maxDim:800,quality:0.45}).then(u=>set('photo',u)).catch(()=>window.alert('La photo n\'a pas pu être traitée. Réessaie ou préviens la direction.'));});}}}/>
  </div>);

  // Lien séjour pour Types 1 & 2 — affiché automatiquement, pas de select terrain
  const sejourField=(type===1||type===2)&&f.bid&&(<div style={{background:'#e8f4fd',borderRadius:8,padding:'8px 12px',fontSize:12,color:'#0d47a1'}}>
    {sejourAuto
      ? sejourAuto._fromStatutAppts
        ? <span>📨 Départ du {fd(sejourAuto.dateDepart)} détecté — la direction identifiera le client.</span>
        : <span>📨 Séjour précédent : <strong>{sejourAuto.nomLocataire||sejourAuto.nom||'—'}</strong> ({fd(sejourAuto.dateDepart||sejourAuto.depart||'')})</span>
      : <span style={{color:'var(--si)'}}>Séjour non trouvé automatiquement — la direction identifiera le client.</span>
    }
  </div>);

  return(<div style={{display:'flex',flexDirection:'column',gap:12}}>
    <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:4}}>
      <button onClick={()=>setStep(1)} className="btn bgh sm">← Retour</button>
      <span style={{fontWeight:700,fontSize:14}}>{TYPES.find(x=>x.t===type)?.emoji} {TYPES.find(x=>x.t===type)?.label}</span>
    </div>

    {/* Type 1 — objet de valeur → coffre */}
    {type===1&&<>{commonFields}
      <div><label className="fl">Description *</label>
        <input value={f.desc} onChange={e=>set('desc',e.target.value)} placeholder="ex : Montre dorée, iPhone noir coque rouge…"/>
      </div>
      {photoField}
      <div><label className="fl">Poids emballé (g) <span style={{fontSize:11,color:'var(--si)'}}>optionnel — pour devis expédition</span></label>
        <input type="number" min="1" value={f.poids||''} onChange={e=>set('poids',e.target.value)} placeholder="ex : 850"/>
      </div>
      {sejourField}
      <div><label className="fl">Notes (où trouvé, état…)</label>
        <textarea rows="2" value={f.notes} onChange={e=>set('notes',e.target.value)}/>
      </div>
      <div style={{background:'#ede7ff',borderRadius:8,padding:'8px 12px',fontSize:12,color:'#4527a0'}}>
        🔒 Coffre-fort — référence à noter sur l&apos;étiquette : <strong style={{fontSize:14,letterSpacing:'.05em'}}>{refPreview}</strong>
      </div>
    </>}

    {/* Type 2 — identité / paiement */}
    {type===2&&<>{commonFields}
      <div><label className="fl">Sous-type *</label>
        <div style={{display:'flex',gap:8}}>
          <label style={{display:'flex',alignItems:'center',gap:6,cursor:'pointer'}}>
            <input type="radio" name="sousType" value="identite" checked={f.sousType==='identite'} onChange={()=>set('sousType','identite')}/>
            🪪 Pièce d&apos;identité (CNI, passeport…)
          </label>
          <label style={{display:'flex',alignItems:'center',gap:6,cursor:'pointer'}}>
            <input type="radio" name="sousType" value="paiement" checked={f.sousType==='paiement'} onChange={()=>set('sousType','paiement')}/>
            💳 Moyen de paiement
          </label>
        </div>
      </div>
      <div><label className="fl">Description *</label>
        <input value={f.desc} onChange={e=>set('desc',e.target.value)} placeholder="ex : CNI au nom de Martin, carte Visa Boursorama…"/>
      </div>
      {sejourField}
      <div style={{background:'#e3f2fd',borderRadius:8,padding:'8px 12px',fontSize:12,color:'#0d47a1'}}>
        🗓 Délai légal : 1 mois pour récupération, puis {f.sousType==='identite'?'dépôt au commissariat':'destruction'}.
      </div>
    </>}

    {/* Type 4 — divers → bac */}
    {type===4&&<>{commonFields}
      <div><label className="fl">Catégorie</label>
        <select value={f.cat} onChange={e=>set('cat',e.target.value)}>
          <option value="">—</option>
          {OT_CATS.map(c=><option key={c}>{c}</option>)}
        </select>
      </div>
      <div><label className="fl">Description *</label>
        <input value={f.desc} onChange={e=>set('desc',e.target.value)} placeholder="ex : Pull gris taille M, livre de recettes…"/>
      </div>
      {photoField}
      <div><label className="fl">Poids emballé (g) <span style={{fontSize:11,color:'var(--si)'}}>optionnel — pour devis expédition</span></label>
        <input type="number" min="1" value={f.poids||''} onChange={e=>set('poids',e.target.value)} placeholder="ex : 850"/>
      </div>
      <div><label className="fl">Notes</label>
        <textarea rows="2" value={f.notes} onChange={e=>set('notes',e.target.value)} placeholder="État, où trouvé…"/>
      </div>
      <div style={{background:'#fff3e0',borderRadius:8,padding:'8px 12px',fontSize:12,color:'#e65100'}}>
        📦 Bac — référence à noter sur l&apos;étiquette : <strong style={{fontSize:14,letterSpacing:'.05em'}}>{refPreview}</strong>
      </div>
    </>}

    <div style={{display:'flex',gap:8,justifyContent:'flex-end',marginTop:4}}>
      <button onClick={onClose} className="btn bgh">Annuler</button>
      <button onClick={save} disabled={!f.bid||!f.desc} className="btn bor">
        📦 Déclarer
      </button>
    </div>
  </div>);
}
